import { ref } from 'vue'
import { listTags, type Tag } from '@/api'
import { colorForTag } from '@/todos/tags'

// The user's own tags (color, aliases), loaded once and shared, so the chips of every todo can use the colors;
// the tag editor in Settings replaces them after each change.
const tags = ref<Tag[]>([])
let loading: Promise<void> | null = null

export function setTags(next: Tag[]): void {
  tags.value = next
}

export function reloadTags(): Promise<void> {
  loading = listTags()
    .then(setTags)
    .catch(() => {
      // (the colors are decoration, a todo list works without them)
    })
  return loading
}

export function useTags() {
  if (loading === null) void reloadTags()
  return { tags, colorFor: (name: string) => colorForTag(tags.value, name) }
}
